module.exports = __webpack_public_path__ + "img/DIY.ff12259.jpg";